import React from "react";
import i18n from "@/i18n";

import { VacancyApplicant } from "../../../model/VacancyApplicant.interface";
import BFValueDisplay from "@/modules/abstract-ui/data/value-display/BFValueDisplay";
import BfIcon from "@/modules/abstract-ui/icon/BfIcon";

type Props = {
  applicant: VacancyApplicant;
};

// TODO SJ: show no documents if no attachments are present

const VacancyApplicantOtherInformation = (props: Props) => {
  const { applicant } = props;

  return (
    <div>
      <div className="__h3 padding-top-10">
        {i18n.t(
          "apTemplate:Vacancy.Applicant.Label.OtherInformation",
          "Sonstige Informationen"
        )}
      </div>
      <div className="__grid __grid-cols-3 __grid-gap-10 __justify-items-start padding-top-10 __align-items-start">
        <BFValueDisplay
          label={i18n.t(
            "apTemplate:Vacancy.Applicant.Label.HasPets",
            "Hat Haustiere"
          )}
          value={
            <BfIcon
              size="sm"
              data={`${applicant.hasPets ? "check" : "close"}`}
              type="light"
            />
          }
        />
        <BFValueDisplay
          label={i18n.t(
            "apTemplate:Vacancy.Applicant.Label.IsSmoker",
            "Ist Raucher"
          )}
          value={
            <BfIcon
              size="sm"
              data={`${applicant.isSmoker ? "check" : "close"}`}
              type="light"
            />
          }
        />
        <BFValueDisplay
          label={i18n.t(
            "apTemplate:Vacancy.Applicant.Label.HasLegalRecord",
            "eidestattliche Versicherung / Haftbefehler letzte 3 Jahre"
          )}
          value={
            <BfIcon
              size="sm"
              data={`${applicant.hasLegalRecord ? "check" : "close"}`}
              type="light"
            />
          }
        />
        <BFValueDisplay
          label={i18n.t(
            "apTemplate:Vacancy.Applicant.Label.HasEviction",
            "Räumungstitel letzte 5 Jahre"
          )}
          value={
            <BfIcon
              size="sm"
              data={`${applicant.hasEviction ? "check" : "close"}`}
              type="light"
            />
          }
        />
        <BFValueDisplay
          label={i18n.t(
            "apTemplate:Vacancy.Applicant.Label.HasInsolvency",
            "Insolvenzen letzte 5 Jahre"
          )}
          value={
            <BfIcon
              size="sm"
              data={`${applicant.hasInsolvencyProceeding ? "check" : "close"}`}
              type="light"
            />
          }
        />
      </div>
    </div>
  );
};

export default VacancyApplicantOtherInformation;
